"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var classNames = require("classnames");

var withStyles_1 = require("../decorators/withStyles");

var Space_styles_1 = require("./Space.styles");

var decorators_1 = require("../decorators/decorators");

var withResponsive_1 = require("../decorators/withResponsive");

var mobileStylesHelper_1 = require("../assets/mobileStylesHelper");

var NakedSpace = function NakedSpace(props) {
  var _a;

  var classes = props.classes,
      vertical = props.vertical,
      inline = props.inline,
      tiny = props.tiny,
      small = props.small,
      large = props.large,
      huge = props.huge;
  return React.createElement("div", {
    className: classNames(classes.space, (_a = {}, _a[classes.vertical] = vertical, _a[classes.inline] = inline, _a[classes.tiny] = tiny, _a[classes.small] = small, _a[classes.large] = large, _a[classes.huge] = huge, _a), mobileStylesHelper_1.createMobileClasses(props))
  });
};

var Space = decorators_1.combineDecorators(withResponsive_1.withResponsive, withStyles_1.withStyles(Space_styles_1.styles))(NakedSpace);
exports.default = Space;